/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ComponentBase from '../../ComponentBase';
import LifeCyclePropertyType, { LifeCycle } from '../../LifeCycle';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/**
 *  Used by configuratorComponent to set node active
 *  at different lifeCycles.
 */
@cc._decorator.ccclass
export default class SetNodeActiveComponent extends ComponentBase
{
    /**
     * LifeCycle during which to set active property.
     */
    @property({ type: LifeCyclePropertyType })
    protected lifeCycle: LifeCycle = LifeCycle.onLoad;
    public get LifeCycle(): LifeCycle { return this.lifeCycle; }

    /**
     * Value to set active property.
     */
    @property()
    protected toActive: boolean = true;
    public get ToActive(): boolean { return this.toActive; }
}
